export default "__VITE_ASSET__DbYW3QEB__"